/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Changes_TitleInputs */

const en_agb_changes_title = /** @type {(inputs: Agb_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Changes to Terms`)
};

const de_agb_changes_title = /** @type {(inputs: Agb_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Aenderungen der AGB`)
};

const fr_agb_changes_title = /** @type {(inputs: Agb_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Modifications des conditions`)
};

const es_agb_changes_title = /** @type {(inputs: Agb_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Modificaciones de las condiciones`)
};

const it_agb_changes_title = /** @type {(inputs: Agb_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Modifiche ai termini`)
};

const nl_agb_changes_title = /** @type {(inputs: Agb_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Wijzigingen in de voorwaarden`)
};

const pl_agb_changes_title = /** @type {(inputs: Agb_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Zmiany regulaminu`)
};

const fi_agb_changes_title = /** @type {(inputs: Agb_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Ehtojen muutokset`)
};

const da_agb_changes_title = /** @type {(inputs: Agb_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Ændringer af vilkår`)
};

const sv_agb_changes_title = /** @type {(inputs: Agb_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Ändringar av villkor`)
};

/**
* | output |
* | --- |
* | "11. Changes to Terms" |
*
* @param {Agb_Changes_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_changes_title = /** @type {((inputs?: Agb_Changes_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Changes_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_changes_title(inputs)
	if (locale === "fr") return fr_agb_changes_title(inputs)
	if (locale === "es") return es_agb_changes_title(inputs)
	if (locale === "it") return it_agb_changes_title(inputs)
	if (locale === "nl") return nl_agb_changes_title(inputs)
	if (locale === "pl") return pl_agb_changes_title(inputs)
	if (locale === "fi") return fi_agb_changes_title(inputs)
	if (locale === "da") return da_agb_changes_title(inputs)
	if (locale === "sv") return sv_agb_changes_title(inputs)
	return en_agb_changes_title(inputs)
});